 $(document).on('click','.custom_serach_cart',function(e){
        e.preventDefault();
        let addToCartForm = $(this).parents('.product-card__form').find('input[name="id"]').val();
        let addToCartQua = $(this).parents('.product-card__form').find('.wpbingo-qty input[name="quantity"]').val();
        // console.log(addToCartForm,addToCartQua);
         var params = {
              type: 'POST',
              url: '/cart/add.js',
              data: {
                quantity: addToCartQua,
                id: addToCartForm
              },
              dataType: 'json',
              success: function(line_item) {
              ajaxCart.load();
                  if($('.js-drawer').length){
                        $('body').addClass('drawer--open');
                    }
                  $('.js-drawer-close').on('click', function() {
                      $('body').removeClass('drawer--open');
                  });
              },
              error: function(XMLHttpRequest, textStatus) {
                  if (typeof errorCallback === 'function') {
                      errorCallback(XMLHttpRequest, textStatus);
                  } else {
                      ShopifyAPI.onError(XMLHttpRequest, textStatus);
                  }
              }
          };
        jQuery.ajax(params);
   });